import { styled } from '@mui/material/styles';
import { Stack, Container, Typography, Box } from '@mui/material';
import Page from '../components/Page';
import OtpForm from 'src/sections/authentication/forgot/OtpForm';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  },
  backgroundColor: process.env.REACT_APP_BACKGROUND
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 450,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));

export default function OtpVerification() {
  const email = localStorage.getItem('email');
  return (
    <RootStyle title={`Login | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src={process.env.REACT_APP_LOGIN}
              sx={{
                padding: 1,
                marginLeft: 1,
                width: 140,
                height: 140
              }}
            />

            <Typography sx={{ fontSize: 25, fontFamily: 'poppinsBold' }}>
              OTP Verification
            </Typography>
            <Typography
              gutterBottom
              sx={{ fontSize: 15, fontFamily: 'poppinsRegular', textAlign: 'center' }}
            >
              {`An OTP has been sent to (${email}). Please check your inbox to verify your account.`}
            </Typography>
          </Stack>

          <OtpForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
